import React, { useEffect } from 'react';
import { ArrowLeft, FileText, Clock, CreditCard, Package, AlertCircle, Scale, RefreshCw, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const goHome = () => {
    window.dispatchEvent(new CustomEvent('nova-navigate', {
      detail: 'home'
    }));
  };
  const sections = [{
    icon: <Package className="text-nova-accent" size={24} data-id="element-392" />,
    title: '1. Servicios Ofrecidos',
    content: <>
          <p className="mb-3" data-id="element-393">
            NovaWeb es una agencia de diseño web que ofrece los siguientes
            planes:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-394">
            <li data-id="element-395">
              <strong className="text-nova-text" data-id="element-396">Landing Page</strong> — Desde
              COP $597.000
            </li>
            <li data-id="element-397">
              <strong className="text-nova-text" data-id="element-398">Sitio Web para Negocio</strong>{' '}
              — Desde COP $897.000
            </li>
            <li data-id="element-399">
              <strong className="text-nova-text" data-id="element-400">Web para Negocio Plus</strong>{' '}
              — Desde COP $1.297.000
            </li>
          </ul>
          <p className="mt-3" data-id="element-401">
            El alcance exacto de cada plan está descrito en la sección de
            servicios de nuestro sitio web. Cualquier funcionalidad fuera del
            alcance del plan contratado se cotiza por separado.
          </p>
        </>
  }, {
    icon: <CreditCard className="text-nova-accent" size={24} data-id="element-402" />,
    title: '2. Precios y Forma de Pago',
    content: <>
          <p className="mb-3" data-id="element-403">
            Todos los precios están expresados en pesos colombianos (COP) y son
            referenciales "desde". El valor final puede variar según la
            complejidad del proyecto y se confirmará por escrito antes de
            iniciar.
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-404">
            <li data-id="element-405">
              <strong className="text-nova-text" data-id="element-406">Anticipo:</strong> 50% al
              confirmar el proyecto para iniciar el diseño.
            </li>
            <li data-id="element-407">
              <strong className="text-nova-text" data-id="element-408">Saldo:</strong> 50% restante
              antes de la publicación final del sitio.
            </li>
            <li data-id="element-409">
              Aceptamos transferencia bancaria, Nequi, Daviplata y otros medios
              acordados.
            </li>
            <li data-id="element-410">
              Los precios no incluyen IVA salvo que se indique lo contrario.
            </li>
          </ul>
        </>
  }, {
    icon: <Clock className="text-nova-accent" size={24} data-id="element-411" />,
    title: '3. Tiempos de Entrega',
    content: <>
          <p className="mb-3" data-id="element-412">
            Los tiempos estimados, contados en días hábiles desde la entrega
            completa de la información por parte del cliente, son:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-413">
            <li data-id="element-414">
              <strong className="text-nova-text" data-id="element-415">Landing Page:</strong> 5 a 7
              días hábiles
            </li>
            <li data-id="element-416">
              <strong className="text-nova-text" data-id="element-417">
                Sitio Web para Negocio:
              </strong>{' '}
              10 a 15 días hábiles
            </li>
            <li data-id="element-418">
              <strong className="text-nova-text" data-id="element-419">Web para Negocio Plus:</strong>{' '}
              15 a 20 días hábiles
            </li>
          </ul>
          <p className="mt-3" data-id="element-420">
            Estos tiempos pueden extenderse si el cliente demora en entregar
            contenidos, aprobar revisiones o realizar pagos.
          </p>
        </>
  }, {
    icon: <RefreshCw className="text-nova-accent" size={24} data-id="element-421" />,
    title: '4. Revisiones y Cambios',
    content: <>
          <p className="mb-3" data-id="element-422">
            Cada plan incluye un número razonable de revisiones durante el
            proceso de diseño:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-423">
            <li data-id="element-424">Hasta 2 rondas de revisión sobre el diseño propuesto.</li>
            <li data-id="element-425">
              Ajustes menores de texto e imágenes antes de la publicación.
            </li>
            <li data-id="element-426">
              Cambios estructurales mayores o rediseños completos se cotizan por
              separado.
            </li>
            <li data-id="element-427">
              Una vez publicado y entregado el sitio, cualquier modificación
              posterior se cotiza como servicio adicional.
            </li>
          </ul>
        </>
  }, {
    icon: <Package className="text-nova-accent" size={24} data-id="element-428" />,
    title: '5. Hosting, Dominio y Correos',
    content: <>
          <p className="mb-3" data-id="element-429">
            Todos los planes incluyen{' '}
            <strong className="text-nova-text" data-id="element-430">1 año</strong> de:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-431">
            <li data-id="element-432">Hosting (alojamiento web)</li>
            <li data-id="element-433">Dominio (.com, .co u otra extensión estándar disponible)</li>
            <li data-id="element-434">Correos corporativos según el plan (1, 2 o 3)</li>
          </ul>
          <p className="mt-3" data-id="element-435">
            A partir del segundo año, la renovación de hosting, dominio y
            correos se cotiza por separado y debe ser pagada antes del
            vencimiento para mantener el sitio activo. NovaWeb notificará al
            cliente antes de la fecha de vencimiento, pero la responsabilidad
            final de renovar recae en el cliente.
          </p>
        </>
  }, {
    icon: <AlertCircle className="text-nova-accent" size={24} data-id="element-436" />,
    title: '6. Servicios No Incluidos',
    content: <>
          <p className="mb-3" data-id="element-437">
            Salvo acuerdo escrito en contrario, los siguientes servicios{' '}
            <strong className="text-nova-text" data-id="element-438">NO están incluidos</strong> en
            los planes:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-439">
            <li data-id="element-440">Branding avanzado y manual de marca completo</li>
            <li data-id="element-441">Cambios ilimitados después de la entrega</li>
            <li data-id="element-442">Campañas publicitarias (Google Ads, Meta Ads)</li>
            <li data-id="element-443">SEO mensual posicionamiento orgánico continuo</li>
            <li data-id="element-444">Fotografía y/o video profesional</li>
            <li data-id="element-445">Integraciones avanzadas (CRM, ERP, pasarelas custom)</li>
            <li data-id="element-446">Carga masiva de productos en tiendas online</li>
            <li data-id="element-447">Correos adicionales fuera del plan contratado</li>
            <li data-id="element-448">Soporte y mantenimiento mensual post-entrega</li>
          </ul>
        </>
  }, {
    icon: <FileText className="text-nova-accent" size={24} data-id="element-449" />,
    title: '7. Propiedad Intelectual',
    content: <>
          <p className="mb-3" data-id="element-450">Una vez completado el pago total del proyecto:</p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-451">
            <li data-id="element-452">
              El cliente recibe los derechos de uso del diseño final y del
              contenido entregado.
            </li>
            <li data-id="element-453">
              El logotipo básico y branding entregados son de uso exclusivo del
              cliente.
            </li>
            <li data-id="element-454">
              NovaWeb conserva el derecho de mostrar el proyecto en su
              portafolio y materiales promocionales.
            </li>
            <li data-id="element-455">
              El código base, librerías y herramientas técnicas utilizadas
              siguen perteneciendo a sus respectivos autores y NovaWeb.
            </li>
          </ul>
          <p className="mt-3" data-id="element-456">
            El cliente declara que todo el contenido (textos, imágenes, logos
            previos, etc.) que entrega para el proyecto cuenta con los derechos
            correspondientes y exime a NovaWeb de cualquier reclamación por uso
            indebido.
          </p>
        </>
  }, {
    icon: <Scale className="text-nova-accent" size={24} data-id="element-457" />,
    title: '8. Limitación de Responsabilidad',
    content: <>
          <p className="mb-3" data-id="element-458">
            NovaWeb se compromete a entregar un trabajo profesional y de
            calidad, pero no garantiza:
          </p>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-459">
            <li data-id="element-460">
              Resultados comerciales específicos (cantidad de clientes, ventas o
              leads).
            </li>
            <li data-id="element-461">
              Posicionamiento en primeras posiciones de Google (el SEO básico
              incluido es una optimización inicial, no un servicio mensual).
            </li>
            <li data-id="element-462">
              Disponibilidad 100% ininterrumpida del hosting (depende del
              proveedor).
            </li>
          </ul>
          <p className="mt-3" data-id="element-463">
            En ningún caso NovaWeb será responsable por daños indirectos, lucro
            cesante o pérdidas comerciales derivadas del uso del sitio web
            entregado.
          </p>
        </>
  }, {
    icon: <AlertCircle className="text-nova-accent" size={24} data-id="element-464" />,
    title: '9. Cancelaciones y Reembolsos',
    content: <>
          <ul className="space-y-2 list-disc list-inside text-nova-text-muted" data-id="element-465">
            <li data-id="element-466">
              Si el cliente cancela antes de iniciar el diseño, se reembolsa el
              anticipo menos los costos de dominio y hosting si ya fueron
              adquiridos.
            </li>
            <li data-id="element-467">
              Si la cancelación ocurre durante el diseño, no se reembolsa el
              anticipo pues cubre el trabajo ya realizado.
            </li>
            <li data-id="element-468">
              Una vez publicado el sitio y pagado el saldo final, no aplican
              reembolsos.
            </li>
          </ul>
        </>
  }, {
    icon: <Scale className="text-nova-accent" size={24} data-id="element-469" />,
    title: '10. Ley Aplicable y Jurisdicción',
    content: <p data-id="element-470">
          Estos términos se rigen por las leyes de la República de Colombia.
          Cualquier controversia se intentará resolver de buena fe entre las
          partes; de no lograrse, será competencia de los jueces civiles del
          domicilio del prestador del servicio.
        </p>
  }, {
    icon: <Mail className="text-nova-accent" size={24} data-id="element-471" />,
    title: '11. Aceptación y Contacto',
    content: <>
          <p className="mb-3" data-id="element-472">
            Al confirmar un proyecto y realizar el pago del anticipo, el cliente
            acepta íntegramente estos Términos de Servicio.
          </p>
          <ul className="space-y-2 text-nova-text-muted" data-id="element-473">
            <li data-id="element-474">
              <strong className="text-nova-text" data-id="element-475">
                NovaWeb — Agencia de Diseño Web
              </strong>
            </li>
            <li data-id="element-476">
              WhatsApp:{' '}
              <a href="https://wa.me/573508108717" className="text-nova-accent hover:underline" data-id="element-477">
                3508108717
              </a>
            </li>
          </ul>
        </>
  }];
  return <div className="min-h-screen bg-nova-bg text-nova-text font-poppins pt-32 pb-24" data-id="element-478">
      <div className="max-w-4xl mx-auto px-6" data-id="element-479">
        <button onClick={goHome} className="inline-flex items-center gap-2 text-nova-text-muted hover:text-nova-accent transition-colors mb-8 text-sm font-medium" data-id="element-480">
          <ArrowLeft size={18} data-id="element-481" />
          Volver al inicio
        </button>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-482">
          <div className="flex items-center gap-3 mb-4" data-id="element-483">
            <FileText className="text-nova-accent" size={36} data-id="element-484" />
            <h1 className="text-3xl md:text-4xl font-bold" data-id="element-485">
              Términos de Servicio
            </h1>
          </div>
          <p className="text-nova-text-muted mb-12" data-id="element-486">
            Última actualización: enero de 2026 · NovaWeb — Agencia de Diseño
            Web
          </p>

          <div className="bg-nova-card border border-nova-bg-alt rounded-2xl p-6 md:p-8 mb-12" data-id="element-487">
            <p className="text-nova-text-muted leading-relaxed" data-id="element-488">
              Bienvenido a <strong className="text-nova-text" data-id="element-489">NovaWeb</strong>.
              Estos Términos de Servicio regulan la contratación y prestación de
              nuestros servicios de diseño web profesional, landing pages,
              sitios web para negocios y planes Plus. Al contratar cualquiera de
              nuestros planes, el cliente acepta los términos descritos a
              continuación.
            </p>
          </div>

          <div className="space-y-8" data-id="element-490">
            {sections.map((section, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-nova-card border border-nova-bg-alt rounded-2xl p-6 md:p-8" data-id="element-491">
                <div className="flex items-center gap-3 mb-4" data-id="element-492">
                  {section.icon}
                  <h2 className="text-xl md:text-2xl font-semibold" data-id="element-493">
                    {section.title}
                  </h2>
                </div>
                <div className="text-nova-text-muted leading-relaxed" data-id="element-494">
                  {section.content}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}